import { useTranslation } from 'react-i18next';

export default function HeroSection() {

  const { t } = useTranslation();

  return (
    <section className="site-hero relative flex items-center bg-gradient-to-r from-amber-600 to-yellow-500 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/img/b2a6e20e92c4f502a0e16d9c2ce57825.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-amber-900/80 to-yellow-800/60"></div>
      </div>
      
      <div className="relative z-10 container mx-auto px-6 flex items-center">
        <div className="max-w-4xl text-white">
          <h1 className="text-6xl font-bold mb-8">{t('about.about1')}</h1>
          <p className="text-2xl leading-relaxed opacity-90 mb-8">{t('about.about6')} </p>
          <p className="text-lg leading-relaxed opacity-80 max-w-3xl">{t('about.about7')}</p>
        </div>
      </div>
      
      {/* Decorative elements */}
      <div className="absolute top-20 right-20 w-32 h-32 border-2 border-white/30 rounded-full animate-pulse"></div>
      <div className="absolute bottom-20 right-40 w-20 h-20 border-2 border-white/20 rounded-full animate-bounce"></div>
      <div className="absolute top-1/2 right-10 w-16 h-16 border-2 border-white/25 rounded-full animate-ping"></div>
    </section>
  );
}
